import { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
  Tooltip,
  Typography,
  Grid,
  makeStyles
} from '@material-ui/core'

// stile CSS generale
const useStyles = makeStyles((theme) => ({
  root: {},
  barContainer: {
    width: '100%',
    margin: 0,
    backgroundColor: 'rgba(2, 70, 96, 0.4)',
    borderRadius: 4,
    padding: theme.spacing(0.75, 1)
  },
  categoryTitle: {
    color: '#efefef',
    fontSize: '0.70rem',
    fontWeight: 600,
    textAlign: 'center',
    paddingBottom: 2,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  subCategoryText: {
    color: '#dfdfdf',
    textAlign: 'center',
    padding: '3px 2px 2px 2px',
    margin: '0 1px',
    fontSize: '0.64rem',
    lineHeight: 1.2,
    letterSpacing: '-0.2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'default'
  }
}))

// componente principale
const AnomaliesCategoryBar = ({ className, anomaliesCategoryStatus, ...rest }) => {
  const classes = useStyles()

  return (
    <Grid container spacing={1} wrap='nowrap' className={clsx(classes.barContainer, className)} {...rest}>
      {anomaliesCategoryStatus.map((category, index) => {
        return (
          <Grid key={index} item style={{ flex: category.subCategory?.length || 1, minWidth: 0 }}>
            <Tooltip title={`${category.label}: ${category.value}`} enterDelay={300}>
              <Typography component='p' variant='caption' className={classes.categoryTitle}>
                {category.label}: <b>{category.value}</b>
              </Typography>
            </Tooltip>
            <Grid container spacing={0.5} wrap='nowrap' alignItems='center' justifyContent='center'>
              {category.subCategory?.map((sub, subIndex) => {
                return (
                  <Grid key={subIndex} item xs style={{ minWidth: 0 }}>
                    <Tooltip title={`${sub.label}: ${sub.value}`} aria-label={`${sub.label}: ${sub.value}`} enterDelay={200}>
                      <Typography
                        component='p'
                        variant='caption'
                        className={classes.subCategoryText}
                        style={{ borderTop: `3px solid ${sub.color}` }}
                      >
                        {sub.label}: <b>{sub.value}</b>
                      </Typography>
                    </Tooltip>
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
        )
      })}
    </Grid>
  )
}

AnomaliesCategoryBar.propTypes = {
  className: PropTypes.string,
  anomaliesCategoryStatus: PropTypes.array
}

AnomaliesCategoryBar.defaultProps = {
  anomaliesCategoryStatus: []
}

export default memo(AnomaliesCategoryBar)
